import React, { useState, useMemo, useCallback, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Home from "./Screens/Home";
import Header from "./Shared_Components/Header";
import Users from "./Screens/Users";
import Products from "./Screens/Products";
import Customers from "./Screens/CustomerScreens/Customers";
import Loans from "./Screens/Loans";
import StartofDay from "./Screens/StartofDay";
import Claims from "./Screens/Claims/Claims";
import Collections from "./Screens/Collections";
import Logs from "./Screens/Logs";
import CashFlow from "./Screens/Reports/CashFlow";
import CNYCheck from "./Screens/Reports/CNYCheck";
import DefaultedLoan from "./Screens/Reports/DefaultedLoan";
import DuplicateLoan from "./Screens/Reports/DuplicateLoan";
import MyStamp from "./Screens/Reports/MyStamp";
import ProfitReport from "./Screens/Reports/ProfitReport";
import ProfitShare from "./Screens/Reports/ProfitShare";
import Stamp from "./Screens/Reports/Stamp";
import TransactionReport from "./Screens/Reports/TransactionReport";
import ClearDb from "./Screens/DbAction/ClearDb";
import ImportBasics from "./Screens/DbAction/ImportBasics";
import CashPlus from "./Screens/Cash/CashPlus";
import CashStart from "./Screens/Cash/CashStart";
import UserSettings from "./Screens/UserSettings";
import PrivateRoute from "./PrivateRoute";
import RegisterUser from "./Screens/RegisterUser";
import Login from "./Screens/Login";
import CustomerDetailHeader from "./Screens/CustomerScreens/CustomerDetailHeader";
import CustomerDetailIdCheck from "./Screens/CustomerScreens/CustomerDetailIdCheck";
import CustomerDetailNickname from "./Screens/CustomerScreens/CustomerDetailNickname";
import TransactionList from "./Screens/Transactions/TransactionList";
import AddTransactions from "./Screens/Transactions/AddTransactions";
import LoanDetail from "./Screens/LoanDetail";
import { IconButton } from "@material-ui/core";
import { Palette } from "@material-ui/icons";
import addCashReconciliation from "./Screens/Cash/addCashReconciliation";
import ProfitDefinition from "./Screens/ProfitDefinition";
import GetStarted from "./Screens/GetStarted";
import LoanEditTransaction from "./Screens/Transactions/LoanEditTransaction";

function App() {
  const [showPalette, setShowPalette] = useState(false);
  // const location = useLocation();
  // const isHomePage = location.pathname === "/";
  const [selectedColor, setSelectedColor] = useState(() => {
    return sessionStorage.getItem("selectedColor") || "#e11d48";
  });

  useEffect(() => {
    sessionStorage.setItem("selectedColor", selectedColor);
  }, [selectedColor]);

  const setSelectedColorMemoized = useCallback((color) => {
    setSelectedColor(color);
  }, []);

  const selectedColorMemoized = useMemo(() => {
    return selectedColor;
  }, [selectedColor, showPalette]);

  return (
    <Router>
      <Header colorTheme={selectedColor} />
      <Routes>
        <Route
          exact
          path="/"
          element={<GetStarted colorTheme={selectedColor} />}
        />
        <Route path="/login" element={<Login colorTheme={selectedColor} />} />
        <Route path="/register_user" element={<RegisterUser />} />
        <Route
          path="/home"
          element={<PrivateRoute Component={Home} colorTheme={selectedColor} />}
        />
        <Route
          exact
          path="/users"
          element={
            <PrivateRoute Component={Users} colorTheme={selectedColor} />
          }
        />
        <Route
          exact
          path="/products"
          element={
            <PrivateRoute Component={Products} colorTheme={selectedColor} />
          }
        />
        <Route
          exact
          path="/loans"
          element={
            <PrivateRoute Component={Loans} colorTheme={selectedColor} />
          }
        />
        <Route
          exact
          path="/loans/detail"
          element={
            <PrivateRoute Component={LoanDetail} colorTheme={selectedColor} />
          }
        />
        <Route
          exact
          path="/start_of_day"
          element={
            <PrivateRoute Component={StartofDay} colorTheme={selectedColor} />
          }
        />

        <Route
          exact
          path="/collections"
          element={
            <PrivateRoute Component={Collections} colorTheme={selectedColor} />
          }
        />

        {/* claim routes  */}
        <Route
          exact
          path="/claims"
          element={
            <PrivateRoute Component={Claims} colorTheme={selectedColor} />
          }
        />
        {/* <Route exact path="/claims/add_claim" element={<PrivateRoute Component={Claims} />} /> */}

        {/* nested routes for customer flow */}
        <Route
          exact
          path="/customers/overview"
          element={
            <PrivateRoute Component={Customers} colorTheme={selectedColor} />
          }
        />
        <Route
          exact
          path="/customers/detail_id"
          element={
            <PrivateRoute
              Component={CustomerDetailIdCheck}
              colorTheme={selectedColor}
            />
          }
        />
        <Route
          exact
          path="/customers/header/:id"
          element={
            <PrivateRoute
              Component={CustomerDetailHeader}
              colorTheme={selectedColor}
            />
          }
        />
        <Route
          exact
          path="/customers/add_nickname"
          element={
            <PrivateRoute
              Component={CustomerDetailNickname}
              colorTheme={selectedColor}
            />
          }
        />

        {/* Transaction routes */}
        <Route
          exact
          path="/transaction/list"
          element={
            <PrivateRoute
              Component={TransactionList}
              colorTheme={selectedColor}
            />
          }
        />
        <Route
          exact
          path="/transaction/add"
          element={
            <PrivateRoute
              Component={AddTransactions}
              colorTheme={selectedColor}
            />
          }
        />

        {/* nested routes for cash screens */}
        <Route
          exact
          path="/cash/cash_count"
          element={
            <PrivateRoute Component={CashPlus} colorTheme={selectedColor} />
          }
        />
        <Route
          exact
          path="/cash/add_reconciliation"
          element={
            <PrivateRoute
              Component={addCashReconciliation}
              colorTheme={selectedColor}
            />
          }
        />
        <Route
          exact
          path="/cash/cash_start"
          element={
            <PrivateRoute Component={CashStart} colorTheme={selectedColor} />
          }
        />
        <Route
          exact
          path="/logs"
          element={<PrivateRoute Component={Logs} colorTheme={selectedColor} />}
        />

        {/* nested routes for data base action screens */}
        <Route
          exact
          path="/db_actions/clear_db"
          element={
            <PrivateRoute Component={ClearDb} colorTheme={selectedColor} />
          }
        />
        <Route
          exact
          path="/db_actions/import_basics"
          element={
            <PrivateRoute Component={ImportBasics} colorTheme={selectedColor} />
          }
        />

        {/* nested routes for report screen */}
        <Route
          path="/reports/cash_flow"
          element={
            <PrivateRoute Component={CashFlow} colorTheme={selectedColor} />
          }
        />
        <Route
          path="/reports/cny_check"
          element={
            <PrivateRoute Component={CNYCheck} colorTheme={selectedColor} />
          }
        />
        <Route
          path="/reports/defaulted_loan"
          element={
            <PrivateRoute
              Component={DefaultedLoan}
              colorTheme={selectedColor}
            />
          }
        />
        <Route
          path="/reports/duplicate_loan"
          element={
            <PrivateRoute
              Component={DuplicateLoan}
              colorTheme={selectedColor}
            />
          }
        />
        <Route
          path="/reports/my_stamp_duty"
          element={
            <PrivateRoute Component={MyStamp} colorTheme={selectedColor} />
          }
        />
        <Route
          path="/reports/profit_report"
          element={
            <PrivateRoute Component={ProfitReport} colorTheme={selectedColor} />
          }
        />
        <Route
          path="/reports/profit_def"
          element={
            <PrivateRoute
              Component={ProfitDefinition}
              colorTheme={selectedColor}
            />
          }
        />
        <Route
          path="/reports/profit_share"
          element={
            <PrivateRoute Component={ProfitShare} colorTheme={selectedColor} />
          }
        />
        <Route
          path="/reports/stamp"
          element={
            <PrivateRoute Component={Stamp} colorTheme={selectedColor} />
          }
        />
        <Route
          path="/reports/transaction_report"
          element={
            <PrivateRoute
              Component={TransactionReport}
              colorTheme={selectedColor}
            />
          }
        />

        <Route
          exact
          path="/my_settings"
          element={
            <PrivateRoute Component={UserSettings} colorTheme={selectedColor} />
          }
        />
        <Route
          exact
          path="/loan_head/overview/:id"
          element={
            <PrivateRoute
              Component={LoanEditTransaction}
              colorTheme={selectedColor}
            />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
